import React from 'react';
import './DollarAmountInput.css';

interface DollarAmountInputProps {
  value: string;
  onChange: (value: string) => void;
  min?: number;
  max?: number;
  testId?: string;
  ariaLabel?: string;
  placeholder?: string;
  disabled?: boolean;
  /** Stretch to fill a flex row (e.g. the budget rows). */
  fill?: boolean;
}

/** Dollar increment for the up/down stepper on every funds amount. */
const STEP_USD = 10;

/**
 * A "$"-prefixed number input for funds amounts. The up/down stepper moves in
 * $10 increments and the value is normalized to two decimals on blur. Used for
 * add-funds (page + modals) and team/project budgets so they read alike.
 */
const DollarAmountInput: React.FC<DollarAmountInputProps> = ({
  value,
  onChange,
  min = 0,
  max,
  testId,
  ariaLabel,
  placeholder,
  disabled,
  fill,
}) => {
  const formatOnBlur = () => {
    if (value.trim() === '') return;
    const n = parseFloat(value);
    if (!isNaN(n)) onChange(n.toFixed(2));
  };
  return (
    <span
      className={`dollar-amount-field${fill ? ' dollar-amount-field-fill' : ''}`}>
      <span className="dollar-amount-prefix" aria-hidden="true">
        $
      </span>
      <input
        className="dollar-amount-input"
        type="number"
        inputMode="decimal"
        min={min}
        max={max}
        step={STEP_USD}
        value={value}
        disabled={disabled}
        data-testid={testId}
        aria-label={ariaLabel}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onBlur={formatOnBlur}
      />
    </span>
  );
};

export default DollarAmountInput;
